import { render } from "./market-chart-block.vue?vue&type=template&id=0c8c126c&scoped=true"
import script from "./market-chart-block.vue?vue&type=script&lang=js"
export * from "./market-chart-block.vue?vue&type=script&lang=js"

import "./market-chart-block.vue?vue&type=style&index=0&id=0c8c126c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8c126c"]])

export default __exports__